import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import BoxWithTwoSections from 'components/BoxWithTwoSections';
import { transferDetails as TEXT } from 'locales/en/transfer';

const Attempts = ({ transfer }) => {
  const leftSide = useMemo(
    () => ({
      attempt: transfer.attempt || '-',
      maxAttempts: transfer.max_attempts || '-',
    }),
    [transfer]
  );

  const rightSide = useMemo(
    () => ({
      previousAttempt: transfer.previous_attempt_id ? (
        <Link
          to={`/transfers/${transfer.previous_attempt_id}`}
          className="underline"
        >
          {transfer.previous_attempt_id}
        </Link>
      ) : (
        '-'
      ),
      nextAttempt: '-',
    }),
    [transfer]
  );
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.attemptsHeader}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

Attempts.propTypes = {
  transfer: PropTypes.shape({}),
};
Attempts.defaultProps = {
  transfer: {},
};

export default Attempts;
